import actionLogMessages from './actionLogMessages';
import activationMessages from './activationMessages';
import blackboardListMessages from './blackboardListMessages';
import commonMessages from './commonMessages';
import companyMessages from './companyMessages';
import credibilityCheckMessages from './credibilityCheckMessages';
import deviceMessages from './deviceMessages';
import groupMessages from './groupMessages';
import issueMessages from './issueMessages';
import localeMessage from './localeMessages';
import loginMessages from './loginMessages';
import logoutMessages from './logoutMessages';
import mainTitleBarMessages from './mainTitleBarMessages';
import mapMessages from './mapMessages';
import masterMessages from './masterMessages';
import mediaMessages from './mediaMessages';
import operatorMessages from './operatorMessages';
import remoteMessages from './remoteMessages';
import reportMessages from './reportMessages';
import roleMessages from './roleMessages';
import screenLockMessages from './screenLockMessages';
import staffMessages from './staffMessages';
import timeLineMessages from './timeLineMessages';
import toastMessages from './toastMessages';
import trashMessages from './trashMessages';
import userInfoMessages from './userInfoMessages';
import userPromptMessages from './userPromptMessages';

export default {
  ...actionLogMessages,
  ...activationMessages,
  ...blackboardListMessages,
  ...commonMessages,
  ...companyMessages,
  ...credibilityCheckMessages,
  ...deviceMessages,
  ...groupMessages,
  ...issueMessages,
  ...localeMessage,
  ...loginMessages,
  ...logoutMessages,
  ...mainTitleBarMessages,
  ...mapMessages,
  ...masterMessages,
  ...mediaMessages,
  ...operatorMessages,
  ...remoteMessages,
  ...reportMessages,
  ...roleMessages,
  ...screenLockMessages,
  ...staffMessages,
  ...timeLineMessages,
  ...toastMessages,
  ...trashMessages,
  ...userInfoMessages,
  ...userPromptMessages,
};
